import styled from 'styled-components';

export const InputGroup = styled.div`
    width: 100%;
    height: 100%;

    label {
        font-size: 18px;
        color: #333;
    }

    select {
        padding: 10px 25px;
        border-radius: 3px;
        color: #444;
        border: 1px solid #d4cece;
        font-weight: 600;
        width: 100%;
        @media (max-width: 620px) {
            padding: 8px 15px;
        }
    } 
`;
